export const CommonSections = {
    default: 'default',
} as const

export const PerthNowSections = {
    generic: 'generic',
    news: 'news',
    sport: 'sport',
    business: 'business',
    entertainment: 'entertainment',
    lifestyle: 'lifestyle',
    video: 'video',
    classifieds: 'classifieds',
    politics: 'politics',
    travel: 'travel',
    technology: 'technology',
    opinion: 'opinion',
    'shop-now': 'shop-now',
    'community-news': 'community-news',
    'local-news': 'local-news',
    'read-your-local-paper': 'read-your-local-paper',
    ...CommonSections,
} as const

export type PerthNowSections = typeof PerthNowSections

export const SevenNewsSections = {
    sunrise: 'sunrise',
    entertainment: 'entertainment',
    'the-morning-show': 'the-morning-show',
    spotlight: 'spotlight',
    'big-brother-australia': 'big-brother-australia',
    'sas-australia': 'sas-australia',
    'dancing-with-the-stars': 'dancing-with-the-stars',
    'the-voice-australia': 'the-voice-australia',
    'home-and-away': 'home-and-away',
    'my-kitchen-rules': 'my-kitchen-rules',
    'heartbreak-island': 'heartbreak-island',
    'farmer-wants-a-wife': 'farmer-wants-a-wife',
    'kitchen-nightmares-australia': 'kitchen-nightmares-australia',
    sport: 'sport',
    'whats-for-dinner': 'whats-for-dinner',
    'cooking-with-coles': 'cooking-with-coles',
    agt: 'agt',
    'million-dollar-island': 'million-dollar-island',
    'australian-idol': 'australian-idol',
    lifestyle: 'lifestyle',
    ...CommonSections,
} as const

export type SevenNewsSections = typeof SevenNewsSections

export const TheWestRegionalSections = {
    'albany-advertiser': 'albany-advertiser',
    'great-southern-herald': 'great-southern-herald',
    'augusta-margaret-river-times': 'augusta-margaret-river-times',
    'busselton-dunsborough-times': 'busselton-dunsborough-times',
    'broome-advertiser': 'broome-advertiser',
    'the-kimberley-echo': 'the-kimberley-echo',
    'geraldton-guardian': 'geraldton-guardian',
    'midwest-times': 'midwest-times',
    'bunbury-herald': 'bunbury-herald',
    'harvey-waroona-reporter': 'harvey-waroona-reporter',
    'manjimup-bridgetown-times': 'manjimup-bridgetown-times',
    'south-western-times': 'south-western-times',
    'kalgoorlie-miner': 'kalgoorlie-miner',
    'narrogin-observer': 'narrogin-observer',
    'north-west-telegraph': 'north-west-telegraph',
    'pilbara-news': 'pilbara-news',
    'sound-telegraph': 'sound-telegraph',
    countryman: 'countryman',
} as const

export const TheWestSections = {
    ...CommonSections,
    ...TheWestRegionalSections,
    genwest: 'genwest',
} as const

export type TheWestSections = typeof TheWestSections

// TODO - Add The Nightly Sections when available
export const TheNightlySections = {
    ...CommonSections,
    australia: 'australia',
    opinion: 'opinion',
    world: 'world',
    politics: 'politics',
    business: 'business',
    sport: 'sport',
    society: 'society',
    culture: 'culture',
    lifestyle: 'lifestyle',
    from: 'from',
} as const

export type TheNightlySections = typeof TheNightlySections

export type RoutableNightlySection = keyof Omit<TheNightlySections, 'default'>
